export enum ButtonType {
    EXCLUIR = 0,
    EDITAR = 1,
    DOWNLOAD = 2,
    LIST = 3,
    POPUP = 4,
    START = 5,
    INFO = 6,
    MOVER_ACIMA = 7,
    MOVER_ABAIXO = 8,
    PRANCHETA = 9,
    DOUBLE_ARROW = 10

}
